module.exports = __webpack_public_path__ + "img/uploaddemo-4-a.c9e21dcc.png";